import { createContext, useContext, useEffect, useState } from "react"
import gexf from "graphology-gexf/browser";
import Graph from "graphology";
import raw from "raw.macro";
import { supportedNodeAttribues } from "../config/config";

const undirectedGraph = gexf.parse(Graph, raw("../../data/ptz_drive_full_v1.12.gexf"));
//const directedRint = gexf.parse(Graph, raw("../../data/ptz_drive_full_multi_rint.gexf"));
//const directedN3 = gexf.parse(Graph, raw("../../data/ptz_drive_full_multi_n3.gexf"));
window.graph = undirectedGraph

const GraphContext = createContext()

export function useGraph() {
    const context = useContext(GraphContext)
    if(context === undefined){
        throw new Error('useGraph must be used within a GraphProvider')
    }
    return context
}

export function GraphProvider({children}) {
    const [graph, setGraph] = useState(undirectedGraph)
    const [graphConfig, setGraphConfig] = useState({
        nodeAttributes: []
    })

    useEffect(() => {
        const graphAttributes = Object.keys(
            graph.getNodeAttributes(graph.nodes()[0])
        ).filter((it) => {
            return supportedNodeAttribues.includes(it)
        })
        console.log("Setting", graphAttributes)
        setGraphConfig({...graphConfig, nodeAttributes: graphAttributes})
    }, [graph])

    const value = {graph, graphConfig, setGraph}
    return <GraphContext.Provider value={value}>{children}</GraphContext.Provider>
}